import LocalStorageWrapper from 'bloko/common/storage/LocalStorageWrapper';

const REQUISITES_WARNINGS_STORAGE = 'REQUISITES_WARNINGS';
const SEPARATOR = ',';
const MAX_ITEMS_IN_STORAGE = 10;

type GetAlreadyShownRequisitesWarnings = () => string[];

export const getAlreadyShownRequisitesWarnings: GetAlreadyShownRequisitesWarnings = () =>
    LocalStorageWrapper.getItem(REQUISITES_WARNINGS_STORAGE)?.split(SEPARATOR) || [];

type SetShownRequisitesWarnings = (id: number) => void;

export const setShownRequisitesWarnings: SetShownRequisitesWarnings = (id) => {
    const alreadyShownWarnings = getAlreadyShownRequisitesWarnings();
    const newWarnings = [...alreadyShownWarnings, id.toString()];
    // удаляем записи о показах, если их количество превышает MAX_ITEMS_IN_STORAGE, чтобы не засорять LocalStorage
    if (newWarnings.length > MAX_ITEMS_IN_STORAGE) {
        newWarnings.shift();
    }
    LocalStorageWrapper.setItem(REQUISITES_WARNINGS_STORAGE, newWarnings.join(SEPARATOR));
};
